import { CatalogRepository, CatalogFilterOptions } from '../../domain/repositories/catalog.repository';

export class GetFilterOptionsUseCase {
  constructor(private readonly catalogRepository: CatalogRepository) {}

  async execute(categorySlug?: string): Promise<CatalogFilterOptions> {
    return this.catalogRepository.getFilterOptions(categorySlug);
  }
}
